(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donnas-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('donna-navigation')) {
    customElements.define('donna-navigation', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.dnInitFrame);
        this.dnInitFrame = requestAnimationFrame(() => this.initNavigation());
      }
      initNavigation() {
        if (!this.isConnected || this.dnAbort) return;
        this.dnAbort = new AbortController();
        const options = { signal: this.dnAbort.signal };
        const toggle = this.querySelector('.dn-mobile-toggle');
        const links = this.querySelector('.dn-links');
        const groups = [...this.querySelectorAll('.dn-group')];
        const mobile = window.matchMedia('(max-width: 989px)');
        if (!toggle || !links) return;
        const closeGroups = () => groups.forEach(group => { group.open = false; });
        const setMobileOpen = open => {
          links.hidden = !open;
          toggle.setAttribute('aria-expanded', String(open));
          toggle.lastElementChild.textContent = open ? '\u2212' : '+';
        };
        const sync = () => {
          closeGroups();
          toggle.hidden = !mobile.matches;
          setMobileOpen(!mobile.matches);
        };
        sync();
        mobile.addEventListener('change', sync, options);
        toggle.addEventListener('click', () => {
          setMobileOpen(links.hidden);
          closeGroups();
        }, options);
        groups.forEach(group => {
          group.addEventListener('toggle', () => {
            if (group.open) groups.forEach(other => {
              if (other !== group) other.open = false;
            });
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const openGroup = groups.find(group => group.open);
          if (openGroup) {
            openGroup.open = false;
            openGroup.querySelector('summary').focus();
          } else if (mobile.matches && !links.hidden) {
            setMobileOpen(false);
            toggle.focus();
          }
        }, options);
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) {
            closeGroups();
            if (mobile.matches) setMobileOpen(false);
          }
        }, options);
        this.addEventListener('focusout', event => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) closeGroups();
        }, options);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.dnInitFrame);
        if (this.dnAbort) this.dnAbort.abort();
        this.dnAbort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
